<template>
    <div>
        <div class="d-flex">
            <div class="h6">
                Walkthrough
            </div>
            <div class="d-flex ml-auto">
                <b-form-checkbox
                    size="sm"
                    v-model="article.slide_numbering"
                    :checked="article.slide_numbering"
                    :disabled="disabled"
                    switch
                    @change="toggleSlideNumbering"
                    class="mr-4 mt-1"
                >
                    Slide Numbering
                </b-form-checkbox>
                <b-dropdown variant="outline-primary" size="sm">
                    <template #button-content>
                        Add Slide
                    </template>
                    <b-dropdown-item @click="showQuestionModal = true" :disabled="disabled">
                        <span class="text-primary">
                            <font-awesome-icon :icon="['fad', 'plus-square']" fixed-width />
                        </span>
                        Add Text/Media Block
                    </b-dropdown-item>
                    <b-dropdown-item @click="showAddRelatedMediaModal = true" :disabled="disabled">
                        <span class="text-primary">
                            <font-awesome-icon :icon="['fad', 'photo-video']" fixed-width/>
                        </span>
                        Add Media
                    </b-dropdown-item>
                    <b-dropdown-item @click="showAddPdfModal = true" :disabled="disabled" class="text-primary">
                        <span class="text-primary"><font-awesome-icon :icon="['fad', 'file-pdf']" fixed-width/></span>
                        Add PDF
                    </b-dropdown-item>
                </b-dropdown>

                <b-btn
                    size="sm"
                    variant="outline-info"
                    @click="showSwoPreviewModal = true"
                    class="float-right ml-2"
                >
                    <font-awesome-icon :icon="['fad', 'apple-alt']" fixed-width/>
                    SWO Preview
                </b-btn>
            </div>
        </div>

        <slide-list
            :publication="publication"
            :unit="unit"
            :article="article"
            :disabled="disabled"
            :numbering="article.slide_numbering"
        />

        <swo-preview-modal
            v-model="showSwoPreviewModal"
            @hide="showSwoPreviewModal = false"
            :walkthroughMedia="slides"
            :article="article"
        />

        <add-related-media-modal
            v-model="showAddRelatedMediaModal"
            :publication="publication"
            :article="article"
            :article_related_media="article.related_media"
            @link="linkWalkthroughMedia"
            @hide="showAddRelatedMediaModal = false"
        />

        <upload-pdf-modal
            :visible="showAddPdfModal"
            :publication="publication"
            :article="article"
            @hide="showAddPdfModal = false"
        />

        <question-modal
            v-model="showQuestionModal"
            :unit="unit"
            :article="article"
            @createWalkthroughQuestion="createWalkthroughQuestion"
            @hide="showQuestionModal = false"
            :available_standards="[]"
        />
    </div>
</template>

<script>
import moment from 'moment'
import SlideList from '@/components/article/slides/SlideList'
import SwoPreviewModal from '@/components/article/SWOPreviewModal'
import QuestionModal from '@/components/modals/questions/QuestionModal'
import AddRelatedMediaModal from '@/components/modals/article/related_media/AddRelatedMediaModal'
import UploadPdfModal from '@/components/modals/article/related_media/UploadPdfModal'

export default {
    data: () => ({
        showSwoPreviewModal: false,
        showAddRelatedMediaModal: false,
        showQuestionModal: false,
        showAddPdfModal: false,
    }),
    props: [
        'publication',
        'unit',
        'article',
        'disabled',
    ],
    components: {
        UploadPdfModal,
        AddRelatedMediaModal,
        QuestionModal,
        SwoPreviewModal,
        SlideList,
    },
    computed: {
        slides() {
            const slides = this.$store.getters.slidesByWalkthroughId(this.article.id)

            return slides ? slides : []
        },
    },
    methods: {
        async linkWalkthroughMedia(item) {
            try {
                await this.$store.dispatch('addMediaSlide', {
                    walkthroughId: this.article.id,
                    mediaData: {
                        publication_id: this.publication.id,
                        related_media: item,
                    }
                })
                await this.$store.dispatch('getWalkthroughSlides', this.article.id)
                this.showAddRelatedMediaModal = false
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to create walkthrough media: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }
        },
        async createWalkthroughQuestion(question) {
            try {
                await this.$store.dispatch('addQuestionSlide', {
                    walkthroughId: this.article.id,
                    questionData: {
                        type: question.type,
                        content: question.content,
                        print_view: question.print_view,
                        publication_id: this.publication.id,
                    }
                })
                await this.$store.dispatch('getWalkthroughSlides', this.article.id)
                this.showQuestionModal = false
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to create walkthrough question: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }
        },
        async toggleSlideNumbering(toggle) {
            try {
                await this.axios.patch(`/api/walkthrough/${this.article.id}`, {
                    slide_numbering: toggle,
                })
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to toggle walkthrough slide numbering: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }
        },
    },
}
</script>
